import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { PropertyTax } from '../../model/property-tax';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { Inject, Injectable } from '@angular/core';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { BuildingPropertyTaxAssessment } from '../../model/building-property-tax-assesment';

@Injectable()
export class BuildingPropertyTaxAssessmentService extends DataService<BuildingPropertyTaxAssessment> {
  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, BuildingPropertyTaxAssessment, progressBar, 'building-property-tax-assessment');
  }
}
